module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/golfing@3x_99f3ca.jpg";